import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { DropzoneUploaderComponent } from './components/dropzone-uploader/dropzone-uploader.component';


@NgModule({
    declarations: [
        DropzoneUploaderComponent
    ],
    imports: [
        CommonModule,
        MatIconModule,
        NgxDropzoneModule
    ],
    exports: [
        NgxDropzoneModule,
        DropzoneUploaderComponent
    ]
})
export class UploadersModule {
}



